/*@ngInject*/
module.exports = function() {
	return {
		scope: {
			objectData: '<'
		},
		bindToController: true,
		controllerAs: 'vm',
		controller: function() {

		},
		template: require('./general.directive.html')
	};
};



/** WEBPACK FOOTER **
 ** ./app/shared/directives/object_details_directives/general.directive.js
 **/